import FileHierarchy from "./FileHierarchy";
import { NavigationMenu } from "./NavigationMenu";
import { RequestsNavButton } from "./RequestsNavButton";
import { TracesNavButton } from "./TracesNavButton";

import { useSidebar } from "@/components/ui/sidebar";
import { getModifierKeyDisplay } from "@/utils/shortcuts";

const Navigation = ({
  onToggleObservability,
  isObservabilityOpen,
  liveLogsTooltip = "Requests",
  showObservabilityCaret = true,
  onToggleTraces,
  isTracesOpen,
  showTracesCaret = true,
  onOpenSettings,
}: {
  onToggleObservability?: () => void;
  isObservabilityOpen?: boolean;
  liveLogsTooltip?: string;
  showObservabilityCaret?: boolean;
  onToggleTraces?: () => void;
  isTracesOpen?: boolean;
  showTracesCaret?: boolean;
  onOpenSettings?: () => void;
}) => {
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";

  return (
    <div className="flex h-full flex-col">
      <div className="mx-auto flex w-full flex-shrink-0 flex-col gap-1 border-b py-2">
        {isCollapsed ? (
          <>
            <RequestsNavButton
              isCollapsed
              isObservabilityOpen={isObservabilityOpen}
              onToggleObservability={onToggleObservability}
              liveLogsTooltip={liveLogsTooltip}
              showObservabilityCaret={showObservabilityCaret}
            />
            <TracesNavButton
              isCollapsed
              isTracesOpen={isTracesOpen}
              onToggleTraces={onToggleTraces}
              showTracesCaret={showTracesCaret}
            />
          </>
        ) : (
          <>
            <RequestsNavButton
              isObservabilityOpen={isObservabilityOpen}
              onToggleObservability={onToggleObservability}
              liveLogsTooltip={liveLogsTooltip}
              showObservabilityCaret={showObservabilityCaret}
            />
            <TracesNavButton
              isTracesOpen={isTracesOpen}
              onToggleTraces={onToggleTraces}
              showTracesCaret={showTracesCaret}
            />
          </>
        )}
      </div>

      <div className="min-h-[270px] flex-1 overflow-y-auto overflow-x-hidden">
        <FileHierarchy className="flex-1" />
      </div>

      <div className="mt-auto flex-shrink-0 border-t border-gray-200 bg-gray-50/50">
        <NavigationMenu onOpenSettings={onOpenSettings} />
        {!isCollapsed && (
          <div className="flex items-center justify-end gap-2 px-4 pb-2 text-[11px]">
            <kbd className="pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border border-gray-200 bg-white px-1.5 font-mono text-[10px] font-medium text-gray-600">
              <span className="text-xs">{getModifierKeyDisplay()}</span>K
            </kbd>
            <span className="text-gray-500">Quick search</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navigation;
